export default __webpack_public_path__ + "static/certificates-results-3-7bb5ac750ca2f6b1ef9574a49f715b38.png";